<div class="ask-data">

  <div class="ask-data__header">
    <div>
      <h2 class="ask-data__title">Ask the data</h2>
      <p class="ask-data__subtitle" *ngIf="projectName">{{ projectName }}</p>
    </div>
    <button type="button" class="ask-data__close" title="Close" (click)="close()">&times;</button>
  </div>

  <!-- Picker: shown when the floating button was used somewhere without a project in the URL. -->
  <div class="ask-data__picker" *ngIf="needsProject">
    <p class="ask-data__empty-lead">Which project do you want to ask about?</p>

    <input class="ask-data__picker-search" type="text" [(ngModel)]="projectSearch"
      placeholder="Filter projects…" *ngIf="projects.length" />

    <p class="ask-data__no-rows" *ngIf="loadingProjects">Loading your projects…</p>
    <p class="ask-data__no-rows" *ngIf="!loadingProjects && !projects.length">
      No projects available to ask about.
    </p>

    <div class="ask-data__picker-list" *ngIf="!loadingProjects && projects.length">
      <button type="button" class="ask-data__picker-item" *ngFor="let project of filteredProjects"
        (click)="chooseProject(project)">{{ project.Name }}</button>
    </div>
  </div>

  <div class="ask-data__transcript" #transcript *ngIf="!needsProject">

    <!-- Empty state: say what this can answer instead of showing a bare input. -->
    <div class="ask-data__empty" *ngIf="turns.length === 0">
      <p class="ask-data__empty-lead">
        Ask about this project's readiness tasks or schedule dates. Every answer is read-only, and the
        query behind it is shown alongside so you can check the figures.
      </p>
      <div class="ask-data__examples">
        <button type="button" class="ask-data__example" *ngFor="let example of examples"
          (click)="useExample(example)">{{ example }}</button>
      </div>
    </div>

    <div class="ask-data__turn" *ngFor="let turn of turns">

      <div class="ask-data__question">{{ turn.question }}</div>

      <div class="ask-data__reply">
        <p class="ask-data__failed" *ngIf="turn.failed">
          Something went wrong answering that. Please try again in a moment.
        </p>

        <p class="ask-data__answer" *ngIf="turn.answer">{{ turn.answer }}</p>

        <p class="ask-data__truncated" *ngIf="turn.truncated">
          Showing the first {{ turn.rowCount }} rows — the full result is larger.
        </p>

        <div class="ask-data__table-wrap" *ngIf="turn.rows.length">
          <table class="ask-data__table">
            <thead>
              <tr>
                <th *ngFor="let column of turn.columns">{{ column }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of turn.rows">
                <td *ngFor="let value of row.Values">{{ display(value) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="ask-data__no-rows" *ngIf="!turn.failed && !turn.answer && turn.rows.length === 0 && turn.sql">
          No rows matched.
        </p>

        <div class="ask-data__sql" *ngIf="turn.sql">
          <button type="button" class="ask-data__sql-toggle" (click)="toggleSql(turn)">
            {{ turn.showSql ? 'Hide' : 'Show' }} the query behind this answer
          </button>
          <pre class="ask-data__sql-text" *ngIf="turn.showSql">{{ turn.sql }}</pre>
        </div>
      </div>
    </div>

    <div class="ask-data__thinking" *ngIf="asking">Checking the data…</div>
  </div>

  <div class="ask-data__composer" *ngIf="!needsProject">
    <textarea class="ask-data__input" rows="2" #questionInput [(ngModel)]="question" (keydown)="onKeydown($event)"
      [disabled]="asking" placeholder="Ask about this project's readiness or schedule…"></textarea>
    <button type="button" class="ask-data__send" (click)="ask()" [disabled]="asking || !question.trim()">
      Ask
    </button>
  </div>

  <p class="ask-data__footnote" *ngIf="!needsProject">
    Answers are generated from a read-only query over this project's data only. Check the query before
    relying on a number.
  </p>
</div>
